import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white px-4 py-8 text-gray-900 text-base leading-6 border-t border-orange-200" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-155">
      <div className="mx-auto max-w-3xl text-center" data-id="element-156">

        {/* MARCA */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-orange-500" data-id="element-157">
          🧒 CONSTRUYE PROGRESO™
        </div>

        {/* DESCRIPCIÓN */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-158">
          El sistema anti pantalla N°1 para familias argentinas.
        </p>

        {/* FRASE EMOCIONAL */}
        <p className="text-xs italic text-gray-500 m-0 mb-5" data-id="element-159">
          Porque los primeros años de tu hijo no deberían perderse detrás de una pantalla.
        </p>

        {/* CONTACTO */}
        <div className="mb-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-gray-600" data-id="element-160">
          <span data-id="element-161">📧 construyeprogresoo@gmail.com</span>
          <span className="hidden sm:block text-gray-300" data-id="element-162">•</span>
          <span data-id="element-163">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-300" data-id="element-164">•</span>
          <span data-id="element-165">🌐 www.construyeprogreso.com</span>
        </div>

        {/* DIVISOR */}
        <div className="mb-5 h-px bg-orange-100" data-id="element-166" />

        {/* COPYRIGHT */}
        <p className="text-[10px] text-gray-500 m-0 mb-1" data-id="element-167">
          © Construye Progreso™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-[10px] text-gray-400 m-0 mb-4" data-id="element-168">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>

      </div>
    </footer>;
}